export { default } from "./ThirdPartyPricingV2Mspa";
